import React from "react";
import {t} from "../../../../../dev/helpers/translator";
import Config from "../../../../../dev/config/main";
import LanguageSwitcher from "../../../../../dev/terminal/components/languageSwitcher";
import Link from "react-router/es/Link";
import IndexLink from "react-router/es/IndexLink";
import Balance from '../../../../../dev/terminal/components/balance';
import CasinoFavorites from "../../../../../dev/terminal/containers/header/pieces/casinoFavorit";
import SearchInheader from "../../../../../dev/terminal/components/searchInheader";

export default function headerTemplate () {
    let {user, location} = this.props,
        userId = user.profile && user.profile.id,
        userName = user.profile && user.profile.username,
        pathName = location.pathname;
    return <div className={`header-wrapper-t`}>
        {Config.terminal.enableAgeRestriction && <p className="over-18">{t("Prohibido apostar a menores de 18 años")}</p>}
        <div className="header-container-t">
            <div className="left-column-t">
                <div className="logo-wrapper">
                    <IndexLink to="/" className="logo-v" activeClassName="active"/>
                    <IndexLink to="/" className="product-item-v home" activeClassName="active"/>
                    {
                        Config.headerItems.map((item) => {
                            return item.enabled && <Link to={`/${item.url}`}
                                                         className={`product-item-v ${item.url}`}
                                                         activeClassName="active"
                                                         key={item.url}>
                            </Link>;
                        })
                    }
                </div>
            </div>
            <div className="right-column-t">
                <div className="nav-wrapper">
                    <LanguageSwitcher/>
                    <div className="mini-naw-contain">
                        <ul>
                            {
                                pathName === "/casino" && <CasinoFavorites pathName={location.pathname}/>
                            }
                            {
                                user.loggedIn && <li>
                                    <div className={`single-nav-item ${this.state.userInfo && "active"}`} onClick={this.setHandleClick("userInfo")}>
                                        <p>
                                            <i className="arrow-v-nav profile-v"/>
                                        </p>
                                        <div className="open-d-view">
                                            <ul>
                                                <li>{t("User Name: " + userName)}</li>
                                                <li>{"Id: " + userId}</li>
                                                {
                                                    ((user.loggedInByRFID && Config.terminal.enableSignOutWithRfidButton) ||
                                                        (user.loggedIn && !user.loggedInByRFID)) &&
                                                    <li className="logout-v" onClick={this.logOut()}>{t("SIGN OUT")}</li>
                                                }
                                                {
                                                    (user.loggedIn || user.loggedInByRFID) && <li>
                                                        <div className="single-nav-item" onClick={this.props.openPopup("betHistory")}>
                                                            <p>{t("Bet History")}</p>
                                                        </div>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            }
                        </ul>
                    </div>
                    <div className="mini-naw-contain">
                        <ul>
                            <li className='search-in-header'>
                                {
                                    Config.searchInHeader && <SearchInheader />
                                }
                            </li>
                            <li>
                                <Balance/>
                            </li>
                            {
                                !user.loggedIn && <li>
                                    <div className="single-nav-item" onClick={this.props.openPopup("cashout")}>
                                        <p>{t("Cash out")}</p>
                                    </div>
                                </li>
                            }
                            {
                                !Config.terminal.disableTicket && <li onClick={this.props.openPopup("ticketInManualCheck")}>
                                    <div className="single-nav-item">
                                        <button className="button-view-t">{t("TICKET")}</button>
                                    </div>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}